// Safari will not answer a permissions query for the camera, so there is no way to
// simply ask. This remembers what happened the last time the scanner tried to start,
// which is the answer that matters anyway: a phone that cannot open its camera cannot
// scan, whatever the setting claims.
export type CameraStatus = 'unknown' | 'granted' | 'denied' | 'unavailable'

export const useCameraStatus = () => useState<CameraStatus>('camera-status', () => 'unknown')
